/**
 * Platform detection utilities for web/desktop environment branching.
 *
 * Extension point: when local AI sidecar or local LLM support is added,
 * additional platform capabilities can be detected and exposed here.
 */

export const isDesktop: boolean =
  typeof window !== 'undefined' && '__TAURI_INTERNALS__' in window;

export const isWeb: boolean = !isDesktop;

export function getDesktopOS(): 'macos' | 'windows' | 'linux' | null {
  if (!isDesktop) return null;
  const ua = navigator.userAgent.toLowerCase();
  if (ua.includes('mac')) return 'macos';
  if (ua.includes('win')) return 'windows';
  if (ua.includes('linux')) return 'linux';
  return null;
}

// Restored B2C API and type contracts.
export const MOBILE_BREAKPOINT_PX = 768;

export function isMobileViewport(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false;
  }
  return window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT_PX}px)`).matches;
}
